export const formatApplicationDate = (timestamp) => {
  if (timestamp === null || timestamp === undefined || timestamp === "") return "Not recorded";
  const date = new Date(Number(timestamp) * 1000);
  return Number.isNaN(date.getTime()) ? "Not recorded" : date.toLocaleString(undefined, {
    year: "numeric", month: "short", day: "numeric", hour: "numeric", minute: "2-digit",
  });
};
